import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";

//dados
export interface IIndice {
    idIndice: number,
    nomeIndice: string,
    idComponente: number
}

interface IListagemIndice {
    indices: IIndice[]
    paginacao: IPaginacao,
}

const getAll = async (page = 1, cnpj: string, estado: boolean): Promise<IListagemIndice | Error> => {
    try {

        const urlRelativa = `Indice/cnpj?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&cnpj=${cnpj}&estado=${estado}`;

        const { data } = await Api.get(urlRelativa);

        if (data) {

            return {
                indices: data.indices,
                paginacao: data.paginacao
            }

        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const toggleEnabledById = async (idIndice: number): Promise<void | Error> => {
    try {
        await Api.patch(`Indice/alterarEstado?id=${idIndice}`);
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao habilitar/desabilitar o registro');
    }
};

const create = async (dados: Omit<IIndice, 'idIndice'>): Promise<number | Error> => {
    try {
        const { data } = await Api.post<IIndice>('/Indice', dados);

        if (data) {
            return data.idIndice;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const getById = async (idIndice: number): Promise<IIndice | Error> => {
    try {
        const { data } = await Api.get(`Indice/pesquisarId?id=${idIndice}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const updateById = async (idIndice: number, dados: IIndice): Promise<void | Error> => {
    try {
        await Api.put('Indice', dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};

export const IndiceService = {
    getAll,
    toggleEnabledById,
    create,
    getById,
    updateById,
}